import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GameServer {
    name: string;
    code: string;
}

interface ServerState {
    servers: GameServer[];
    selectedServer: GameServer | null;
    loading: boolean;
    error: string | null;
}

const initialState: ServerState = {
    servers: [],
    selectedServer: null,
    loading: false,
    error: null,
};

const serverSlice = createSlice({
    name: 'server',
    initialState,
    reducers: {
        setServers(state, action: PayloadAction<GameServer[]>) {
            state.servers = action.payload;
            state.error = null;
        },
        setSelectedServer(state, action: PayloadAction<GameServer>) {
            state.selectedServer = action.payload;
            // Save to localStorage
            localStorage.setItem('selectedServerCode', action.payload.code);
            localStorage.setItem('selectedServerName', action.payload.name);
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.loading = action.payload;
        },
        setError(state, action: PayloadAction<string>) {
            state.error = action.payload;
            state.loading = false;
        },
        clearError(state) {
            state.error = null;
        },
        initializeSelectedServer(state) {
            const savedServerCode = localStorage.getItem('selectedServerCode');
            const savedServerName = localStorage.getItem('selectedServerName');

            if (savedServerCode && savedServerName && state.servers.length > 0) {
                const savedServer = state.servers.find(server => server.code === savedServerCode);
                if (savedServer) {
                    state.selectedServer = savedServer;
                } else {
                    // Saved server not found, use first available server
                    state.selectedServer = state.servers[0];
                    localStorage.setItem('selectedServerCode', state.servers[0].code);
                    localStorage.setItem('selectedServerName', state.servers[0].name);
                }
            } else if (state.servers.length > 0) {
                // No saved server, use first available server
                state.selectedServer = state.servers[0];
                localStorage.setItem('selectedServerCode', state.servers[0].code);
                localStorage.setItem('selectedServerName', state.servers[0].name);
            }
        },
    },
});

export const {
    setServers,
    setSelectedServer,
    setLoading,
    setError,
    clearError,
    initializeSelectedServer
} = serverSlice.actions;

export default serverSlice.reducer;
